<template>
  <v-container fluid>
    <v-card>
      <v-toolbar style="background:#F5F5F5" dense>
        <v-toolbar-title style="color:#01579B;font-weight:bold" dense>Trafic des cartes</v-toolbar-title>
      </v-toolbar>
      <v-card-title>
        <v-btn large
        >
          <download-csv :data="cardscount" name="cardqueue.csv">
            <v-icon class="mr-1">mdi-download-circle-outline</v-icon>
            Télécharger CSV
          </download-csv>
        </v-btn
        >
        <v-spacer></v-spacer>
        <v-text-field :id="dynamicID()"
                      v-model="search"
                      append-icon="search"
                      label="Rechercher..."
                      single-line
                      hide-details
        ></v-text-field>
      </v-card-title>
      <v-col sm="12" class="text-center">
        <v-progress-linear
            :active="loading"
            :indeterminate="loading"
            absolute
            top
            color="#01579B"
        ></v-progress-linear>
      </v-col>
      <v-data-table
          :headers="headers"
          :items="cardscount"
          :search="search"
          :items-per-page="15"
          :single-expand="singleExpand"
          :expanded.sync="expanded"
          show-expand
          no-results-text="Aucun résultat"
          no-data-text="Aucun résultat"
          :footer-props="{
              showFirstLastPage: true,
              firstIcon: 'mdi-arrow-collapse-left',
              lastIcon: 'mdi-arrow-collapse-right',
              prevIcon: 'mdi-minus',
              nextIcon: 'mdi-plus'
            }">
        <template v-slot:[`expanded-item`]="{ headers, item }">
          <td :colspan="headers.length">
            <vue-json-pretty :data="item"></vue-json-pretty>
          </td>
        </template>
        <template v-slot:[`item.revisedDate`]="{item}">
          {{ item.revisedDate | formatDate }}
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import apiClient from "../../config/api.js";

function isMobileDevice() {
  return /Mobi|Android/i.test(navigator.userAgent);
}

export default {
  data() {
    return {
      isMobile: isMobileDevice(),
      search: "",
      headers: [
        {text: "ID", value: "id", sortable: false},
        {text: "Date création", value: "createdDate"},
        {text: "Créateur", value: "createUser"},
        {text: "Numéro carte", align: "left", value: "cardNumber"},
        {text: "Nombre d'insertions", value: "count"},
        {text: "Dernière utilisation", value: "revisedDate"}
      ],
      cardscount: [],
      loading: true,
      expanded: [],
      singleExpand: true
    };
  },
  created() {
    apiClient
        .get(`${this.$store.getters.user.baseUrl}/admin/cardscount`)
        .then(response => {
          setTimeout(() => (this.loading = false), 3000);
          this.cardscount = response.data.datas;
        })
        .catch(() => {
          this.loading = false;
        });
  },
  methods: {
    dynamicID() {
      return 'dynamicID-' + Math.floor(Math.random() * Date.now().toString());
    },
  }
};
</script>
<style scoped>
tbody tr:nth-of-type(even) {
  background-color: rgba(236, 237, 237);
}

tbody tr:nth-of-type(odd) {
  background-color: rgb(250, 250, 250);
}
</style>